import { useCallback } from 'react';
import { useOutletContext } from 'react-router-dom';
import { ModuleDashboardPage } from '../../../shared/components/index.js';
import { fetchCommercialDashboard } from '../services/commercialService.js';

const SECTIONS = [
  { id: 'funnel', type: 'bars', chartKey: 'funnel', title: 'Embudo comercial', note: 'Etapas desde ingreso hasta venta.' },
  { id: 'evolucion', type: 'bars', chartKey: 'evolucion', title: 'Evolución de leads', note: 'Por día, semana o mes según período.' },
  { id: 'porEstado', type: 'bars', chartKey: 'porEstado', title: 'Leads por estado' },
  { id: 'porFuente', type: 'bars', chartKey: 'porFuente', title: 'Leads por fuente' },
  { id: 'conversionEtapas', type: 'bars', chartKey: 'conversionEtapas', title: 'Conversión entre etapas' },
  { id: 'estancados', type: 'bars', chartKey: 'estancados', title: 'Leads estancados' },
  { id: 'alertas', type: 'alerts', title: 'Alertas', note: 'Operativas del embudo.' },
  { id: 'tabla', type: 'table', title: 'Oportunidades', note: 'Detalle operativo.' }
];

export default function ComercialPage() {
  const { email } = useOutletContext() || {};
  const loadData = useCallback((f) => fetchCommercialDashboard(f), []);
  return (
    <ModuleDashboardPage
      title="Comercial"
      subtitle="Embudo completo desde el lead hasta reserva o venta."
      email={email}
      loadData={loadData}
      filterOpts={{ showChannel: true, showStatus: true }}
      sections={SECTIONS}
    />
  );
}
